module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "dawn-meta-nav"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "meta-nav-menu"
  }, [_vm._m(0), _c('li', {
    staticClass: "meta-nav-item"
  }, [_vm._m(1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.events.length),
      expression: "events.length"
    }],
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.events.length))])]), _c('li', {
    staticClass: "meta-nav-item meta-nav-user meta-nav-dropdown"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.showDropdown = !_vm.showDropdown
      }
    }
  }, [_vm._v(_vm._s(this.$user.email || 'Welcome !')), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), (_vm.showDropdown) ? _c('div', {
    staticClass: "meta-nav-dropdown"
  }, [_c('ul', {
    staticClass: "meta-nav-dropdown-menu"
  }, [_c('li', {
    staticClass: "meta-nav-dropdown-title"
  }, [_c('span', [_vm._v(_vm._s(this.$user.email))]), _c('span', {
    staticClass: "close-icon",
    on: {
      "click": function($event) {
        _vm.showDropdown = !_vm.showDropdown
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])]), _c('li', {
    staticClass: "meta-nav-dropdown-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('My Profile')))])]), _c('li', {
    staticClass: "meta-nav-dropdown-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('My Settings')))])]), _c('li', {
    staticClass: "meta-nav-dropdown-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "meta-nav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fal fa-question-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-bell"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d17f5c42","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edMetaNav/index.vue
// module id = ePYG
// module chunks = 13 14